import { useCallback, useEffect, useMemo, useState } from "react";
import { isEqual } from "lodash-es";

import { useThermowatch } from "./ThermowatchTemplate";
import { Zone } from "./types";
import ZoneList from "./ZoneList";

const ThermowatchZones = () => {
  const [zones, setZones] = useState<Zone[] | null>(null);
  const { value, saved, setValue } = useThermowatch();

  const onZoneListChange = useCallback(
    (newValue: Zone[]) => {
      value.zones = newValue;
      setZones((old) => (old ? [...old] : old));
      setValue(value);
    },
    [value, setValue]
  );

  useEffect(() => {
    if (!value) {
      return;
    }
    setZones((old) => (isEqual(old, value.zones) ? old : value.zones || []));
  }, [value]);

  const userList = useMemo(
    () => <ZoneList value={zones || []} saved={saved?.zones || null} onChange={onZoneListChange} />,
    [zones, saved, onZoneListChange]
  );

  return userList;
};

export default ThermowatchZones;
